import { render } from "./QuantityCounter.vue?vue&type=template&id=a6643122&ts=true"
import script from "./QuantityCounter.vue?vue&type=script&lang=ts"
export * from "./QuantityCounter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__